/**
 * Detect whether we're running inside an Office add-in (Word/Excel/PowerPoint
 * task pane) versus a plain browser tab.
 *
 * We branch the auth flow on this: Office gets the Dialog API path,
 * browser gets auth0-spa-js's loginWithPopup.
 */
export function isOfficeTaskPane(): boolean {
  if (typeof Office === 'undefined') return false;
  if (!Office.context) return false;
  // `host` is only set after Office.onReady has resolved AND the iframe is
  // running as an Office add-in (not a plain web page).
  return !!Office.context.host && !!Office.context.ui?.displayDialogAsync;
}
